import { defineFeature } from "../../app/feature";
import { MappingStudioPage } from "./MappingStudioPage";
import { ProposalPage } from "./ProposalPage";

/** Mapping Studio (task 4080.8; DESIGN-SPEC 20, 28.1): review mapping proposals and approve, edit,
 * or reject them. Decisions are authorized by the mapping API. Owned by the mapping lane. */
export default defineFeature({
  id: "mapping-studio",
  title: "Mapping Studio",
  routes: [
    { path: "/mapping-studio", Component: MappingStudioPage },
    { path: "/mapping-studio/:proposalId", Component: ProposalPage },
  ],
  nav: { label: "Mapping Studio", path: "/mapping-studio", section: "Mappings", order: 10 },
  permissions: ["engagement.read", "mapping.propose", "mapping.certify"],
});
